import { observer } from "mobx-react-lite";
import { isSafari } from "react-device-detect";
import './PrintHeader.scss';

interface PrintHeaderProps {
    title: string;
    subtitle?: string;
    hideDetails?: boolean;
}

export const PrintHeader = observer((props: PrintHeaderProps) => {
    return (
        <div
            className={`print-visible print-header-main w-full ${isSafari ? 'relative' : 'fixed top-0'}`}
        >
            <div className="print-header w-full h-20 text-white flex flex-row justify-between">
                <div className="titles-wrapper flex flex-col justify-center">
                    <h2 className="title flex flex-col justify-center pl-[30px] text-[24px] font-bold">
                        {props.title}{" "}
                        {props.subtitle && <span className="subtitle text-[22px]">{props.subtitle}</span>}
                    </h2>
                </div>
            </div>
        </div>
    );
})